import React, { useEffect, useState } from 'react';
import { InputField, TextAreaField } from '../layouts/FormFields';
import { Button, Form, Space, Switch, Upload } from 'antd';
import axios from 'axios';
import { app } from '../config';
import getHeaders from '../utils/authHeaders';
import LoaderImage from '../pages/LoaderImage';
import NoDataFound from '../layouts/NoDataFound';
import Modal from 'react-bootstrap/Modal';
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const Configapproutes = () => {
  const [renderList, setRenderList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [editloader, setEditLoader] = useState(false);
  const [configs, setConfigs] = useState([]);
  const [updateId, setUpdateId] = useState('');
  let location = useLocation();

  const [isWrite, setIsWrite] = useState(true);

  const getConfigsListing = async () => {
    console.log('Listing API Called');
    setLoader(true);
    // const res = await axios.get(`http://localhost:3200/api/v1/admin/appconfig/view`, { headers: getHeaders() });

    const res = await axios.get(`${app.URL}/api/v1/admin/appconfig/view`, { headers: getHeaders() });
    console.log(res);
    res.data.result.success && setRenderList(res.data.result.data);

    setLoader(false);
  };

  const user = JSON.parse(localStorage.getItem('user'));
  const putAnuraCategoryListing = async (detail, configId) => {
    console.log(detail, configId);
    let routeId = configId;
    let userId = user?.result.data.user.userId;
    detail.userId = userId;
    setEditLoader(true);
    console.log('detail', routeId, detail);
    //   return
    // const res = await axios.post(`http://localhost:3200/api/v1/admin/appconfig/update/${routeId}`, detail, { headers: getHeaders() });

    const res = await axios.post(`${app.URL}/api/v1/admin/appconfig/update/${routeId}`, detail, { headers: getHeaders() });
    setEditLoader(false);
    res.data.result.success && setConfigs([]);
    res.data.result.success && getConfigsListing();
  };

  useEffect(() => {
    getConfigsListing();
    const [filteredRoute] = user.result.data.permission.filter((item) => item.action === location.pathname.slice(1));
    setIsWrite(filteredRoute.isWrite);
  }, []);

  // const onFinish = (values) => {
  //   let updateData = {
  //     displayName: values.displayName,
  //     value: values.value,
  //   };
  //   setUpdateId(values.configId);
  //   putAnuraCategoryListing(updateData, values.configId);
  // };
  // const onFinishFailed = () => {};
  return (
    <div className='dashboard-card pb-5 container-fluid'>
      <div className='row p-0 pb-4'>
        <div className='for-before col-12 col-md-7 head fs-3 fw-bold' style={{ backgroundColor: '#a7c1d9', borderBottomRightRadius: '10px', color: '#FFFFFF' }}>
          App Routes Management
        </div>
      </div>
      <div className='mt-4'>
        {loader && <LoaderImage />}
        {!loader && renderList.length === 0 && <NoDataFound />}
        {!loader && renderList.length > 1 && (
          <table id='customers' className='px-2 facial-scan-cat-table config ' style={{ width: '90%' }}>
            <thead>
              <tr>
                <th className='px-8 col-md-3 col-8'>Name</th>
                <th className='col-md-2 col-4 text-end   '>
                  <span style={{ marginLeft: '40px' }}> WebRoute</span>
                </th>
                <th className='col-md-2 col-3  '>
                  <span style={{ marginLeft: '-20px' }}> MobRoute</span>
                </th>
                <th className='col-md-3 col-2 '>
                  <span style={{ marginLeft: '-40px' }}>Index</span>
                </th>
                <th className='col-md-3 col-2'>
                  <span style={{ marginLeft: '-40px' }}> Redirection Url</span>
                </th>

                <th className='col-md-2 col-4 text-start'>ExtraRoute</th>
                <th className='col-md-2 col-4 text-start'>
                  <span style={{ visibility: 'hidden' }}>Action</span>
                </th>
              </tr>
            </thead>
          </table>
        )}
        {!loader && renderList.map((item, indx) => <ConfigurationDetails isWrite={isWrite} indx={indx} item={item} editloader={editloader} setUpdateId={setUpdateId} updateId={updateId} configs={configs} setConfigs={setConfigs} putAnuraCategoryListing={putAnuraCategoryListing} />)}
      </div>
    </div>
  );
};

const ConfigurationDetails = ({ isWrite, indx, item, updateId, configs, setConfigs, editloader, setUpdateId, putAnuraCategoryListing }) => {
  const [videoUrl, setVideoUrl] = useState(item.value);
  const [contentType, setContentType] = useState();
  const [uplVid, setuplVid] = useState(true);
  const [isActive, setisActive] = useState();
  // State management for image
  const [imageUrl, setImageUrl] = useState(item.value);
  const [uplImg, setuplImg] = useState(true);

  // Video related functions
  const VideoToggle = () => {
    setVideoUrl('');
    setTimeout(() => setVideoUrl(item.value), 500);
  };

  // Image related functions
  const ImageToggle = () => {
    setImageUrl('');
    setTimeout(() => setImageUrl(item.value), 500);
  };

  const beforeUpload = (file) => {
    console.log(file);
    setVideoUrl('');
    setImageUrl('');
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      console.log('setting image type');
      setContentType('img');
    } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') {
      setContentType('video');
    }
    const isSupportedFileType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
    if (!isSupportedFileType) {
      message.error('You can only upload JPG/PNG/MP4/MKV files!');
    }
    console.log('file Checked');
    const isLtSizeLimit = file.size / 1024 / 1024 < (file.type.includes('video') ? 60 : 5);
    if (!isLtSizeLimit) {
      setLargeFile(true);
      message.error(file.type.includes('video') ? 'Video must be smaller than 60MB!' : 'Image must be smaller than 5MB!');
    }
    console.log('message');
    return isSupportedFileType && isLtSizeLimit;
  };

  const handleuploadChange = (info) => {
    if (info.file.status === 'uploading') {
      return;
    }
    if (info.file.status === 'done') {
      if (info.file.type.includes('video')) {
        info.file ? setVideoUrl(info.file.response.data.Location) : ' ';
      } else {
        info.file ? setImageUrl(info.file.response.data.Location) : ' ';
      }
    }
  };
  //   // console.log("item",item)
  //   useEffect(() => {
  //     if (videoUrl !== item.value || imageUrl !== item.value) {
  //       if (!configs.includes(item.configId)) {
  //         setConfigs([...configs, item.configId]);
  //       }
  //     } else {
  //       const filterId = configs.filter((id) => id !== item.configId);
  //       setConfigs(filterId);
  //     }
  //   }, [videoUrl, imageUrl]);

  const onFinish = (values) => {
    console.log('values', values);
// return
    let updateData = {
      name: values.displayName,
      //mobRoute: item.mobRoute,
      mobRouteActive: values.mobRoute,
      webRouteActive: values.webRoute,
      // webRoute: values.webRoute,
      //webRoute: item.webRoute,
      externalRoute: values.redirectionUrl,
      extraRoute: values.extraRoute,
      index: values.index ? values.index : 1000,
      isMenuRoute: 1,

      //   webRoutes: item.type === 'video' ? videoUrl : item.type === 'num' ? values.value : item.type == 'bool' ? (isActive == true ? '1' : '0') : imageUrl,
    };
    setUpdateId(values.routeId);
    console.log('updateData', updateData);
    //return
    putAnuraCategoryListing(updateData, values.configId);
  };
  const preventKeyPress = (event) => {
    event.preventDefault();
  };

  const onFinishFailed = () => {};
  return (
    <Form
      key={indx}
      name='basic'
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete='off'
      initialValues={{
        remember: true,
        ['displayName']: item.name,
        ['mobRoute']: item.mobRouteActive,
        ['webRoute']: item.webRouteActive,
        ['index']: item.index ? item.index : 1000,
        //['isActive']: item.isActive,
        ['configId']: item.routeId,
        ['extraRoute']: item.extraRoute,
        ['redirectionUrl']: item.externalRoute,
        ['directPrint']: item.value == '1' ? true : false, // Ensuring boolean conversion
      }}
      className='row g-0 align-items-center py-1'
    >
      <InputField
        col='col-md-2 col-3 ml-2'
        name='displayName'
        // label='Name'
        placeholder='Enter  Name'
        rules={[
          {
            required: true,
            message: 'Enter  Name',
          },
        ]}
        onChange={(e) => {
          console.log(e.target.value, item.name, configs);
          if (e.target.value !== item.displayName) {
            if (!configs.includes(item.routeId)) {
              setConfigs([...configs, item.routeId]);
            }
          } else {
            const filterId = configs.filter((id) => id !== item.routeId);
            setConfigs(filterId);
          }
          console.log('e.target.value, item.name,', configs);
        }}
      />
      {/* <Form.Item
        col='col-md-2 col-4'
        name='webRoute'
        // rules={[
        //   {
        //     required: true,
        //     message: 'Please enter Password!',
        //   },
        // ]}
      >
        // <span>{item.webRoute ? 'Yes' : 'False'}</span>
      </Form.Item> */}
      {/* <Form.Item col='col-md-2 col-4' style={{display:'inline'}} className='border '> */}
      {/* <span className='col-md-2 col-4 '>{item.webRoute ? 'Yes' : 'No'}</span> */}
      {/* <InputField
        col='col-md-2 col-4'
        name='webRoute'
        className=' p-0' // Removes box styles
        // label='Name'
        // style={{backgroundColor:'grey'}}
        style={{ color: 'black' }}
        placeholder='Enter  Web Route'
        // rules={[
        //   {
        //     required: true,
        //     message: 'Enter Display Name',
        //   },
        // ]}
        // onKeyDown={(e) => preventKeyPress(e)}
        disabled={true}
        onChange={(e) => {
          // preventKeyPress(e);
          if (e.target.value !== item.webRoute) {
            if (!configs.includes(item.routeId)) {
              setConfigs([...configs, item.routeId]);
            }
          } else {
            const filterId = configs.filter((id) => id !== item.routeId);
            setConfigs(filterId);
          }
        }}
      /> */}

      <Form.Item className='col-md-1 col-3 d-flex justify-content-end align-items-end ml-3 me-0' colon={false} valuePropName='checked' name='webRoute'>
        <Switch
          disabled={item.webRoute ? false : true}
          // checked={item.directPrint == 1}
          onChange={(e) => {
            console.log('config', item, e);
            setisActive(e);
            //  form.setFieldsValue({ [item.configId]: checked });
            //   if (e !== (item.webRoute == 1 ? true : false)) {
            if (!configs.includes(item.routeId)) {
              setConfigs([...configs, item.routeId]);
            }
            // } else {
            // const filterId = configs.filter((id) => id !== item.routeId);

            //setConfigs(filterId);
            //}
          }}
        />
      </Form.Item>
      <Form.Item className='col-md-1 col-3 d-flex justify-content-end align-items-end ml-4  ' colon={false} valuePropName='checked' name='mobRoute'>
        <Switch
          // checked={item.directPrint == 1}
          disabled={item.mobRoute ? false : true}
          onChange={(e) => {
            console.log('config', item, e);
            setisActive(e);
            //  form.setFieldsValue({ [item.configId]: checked });
            //if (e !== (item.mobRoute == 1 ? true : false)) {
            if (!configs.includes(item.routeId)) {
              setConfigs([...configs, item.routeId]);
            }
            // } else {
            // const filterId = configs.filter((id) => id !== item.routeId);
            // setConfigs(filterId);
            //}
          }}
        />
      </Form.Item>
      {/* </Form.Item> */}
      {/* <InputField
        col='col-md-2 col-4'
        name='mobRoute'
        className='border-0'
        // label='Name'
        disabled={true}
        style={{ color: 'black' }}
        // onKeyDown={(e) => preventKeyPress(e)}
        placeholder='Enter Mobile Route'
        // rules={[
        //   {
        //     required: true,
        //     message: 'Enter Display Name',
        //   },
        // ]}
        // readOnly={true}
        onChange={(e) => {
          if (e.target.value !== item.mobRoute) {
            if (!configs.includes(item.routeId)) {
              setConfigs([...configs, item.routeId]);
            }
          } else {
            const filterId = configs.filter((id) => id !== item.routeId);
            setConfigs(filterId);
          }
        }}
      /> */}
      <InputField
        col='col-md-3 col-2 d-flex align-items-center justify-content-center'
        name='index'
        placeholder='Enter Index'
        rules={[
          {
            required: true,
            message: 'Enter Index',
          },
        ]}
        onChange={(e) => {
          if (e.target.value !== item.index) {
            if (!configs.includes(item.routeId)) {
              setConfigs([...configs, item.routeId]);
            }
          } else {
            const filterId = configs.filter((id) => id !== item.routeId);
            setConfigs(filterId);
          }
        }}
      />
      <InputField
        col='col-md-2 col-3 px-2 d-flex  justify-content-start align-items-start'
        name='redirectionUrl'
        placeholder='Enter Redirection URL'
        rules={[{ required: false }]}
        onChange={(e) => {
          if (e.target.value !== item.redirectionUrl) {
            if (!configs.includes(item.routeId)) setConfigs([...configs, item.routeId]);
          } else {
            const filterId = configs.filter((id) => id !== item.routeId);
            setConfigs(filterId);
          }
        }}
      />

      {/* <div className='col-md-2 col-3'>
        <Form.Item className='col-md-4 col-3 d-flex justify-content-center align-items-center' colon={false} valuePropName='checked' name='isActive'>
          <Switch
            // checked={item.directPrint == 1}
            onChange={(e) => {
              console.log('config', item, e);
              setisActive(e);
              //  form.setFieldsValue({ [item.configId]: checked });
              if (e !== (item.isActive == 1 ? true : false)) {
                if (!configs.includes(item.routeId)) {
                  setConfigs([...configs, item.routeId]);
                }
              } else {
                const filterId = configs.filter((id) => id !== item.routeId);

                setConfigs(filterId);
              }
            }}
          />
        </Form.Item>
      </div> */}

      <div className='col-md-1 col-6 text-center'>
        {item.routeId == 4 && (
          <Form.Item className='' colon={false} valuePropName='checked' name='extraRoute'>
            <Switch
              // checked={item.directPrint == 1}
              // disabled={item.extraRoute ? false : true}
              onChange={(e) => {
                console.log('config', item, e);
                setisActive(e);
                //  form.setFieldsValue({ [item.configId]: checked });
                //if (e !== (item.mobRoute == 1 ? true : false)) {
                if (!configs.includes(item.routeId)) {
                  setConfigs([...configs, item.routeId]);
                }
                // } else {
                // const filterId = configs.filter((id) => id !== item.routeId);
                // setConfigs(filterId);
                //}
              }}
            />
          </Form.Item>
        )}
      </div>

      <Form.Item className='d-none selector-main border' colon={false} valuePropName='checked' name='configId'></Form.Item>

      <div className='col-md-1 col-12 text-center mb-4'>
        {configs.includes(item.routeId) && isWrite && (
          <Button type='primary' htmlType='submit' style={{ padding: '0px 12px' }}>
            {editloader && item.routeId === updateId ? <LoadingOutlined /> : 'Update'}
          </Button>
        )}
      </div>

      {/* <Form.Item className='d-none selector-main border' colon={false} valuePropName='checked' name='configId'></Form.Item>
      {configs.includes(item.routeId) && isWrite && (
        <div className='col-3 pb-4'>
          <Button className=' btn btn-primary' htmlType='submit'>
            {editloader && item.routeId === updateId ? <LoadingOutlined /> : 'Update'}
          </Button>
        </div>
      )} */}
    </Form>
  );
};

export default Configapproutes;
